import styled from "@emotion/styled";

export const HostContainer = styled.div`
  display: inline-block;
  margin: 0 1rem 0 0;
`;
